module.exports = __webpack_public_path__ + "img/guanyuwomen.d04deed9.png";